import { Modal } from "@shared/ui";
import CopyFromOthers from "../CopyFromOthers";

interface CopyBriefModalProps {
  open: boolean;
  briefId: string;
  deliverableConfigRefId: string;
  taskId: string;
  campaignInfluencerId: string;
  onClose: () => void;
  refetchInfluencer: () => void;
}

export function CopyBriefModal({
  open,
  briefId,
  deliverableConfigRefId,
  taskId,
  campaignInfluencerId,
  onClose,
  refetchInfluencer,
}: CopyBriefModalProps) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={450}
      title="Copy Requirements"
      styles={{ body: { padding: 0 }, header: { marginBottom: 0 } }}
    >
      <CopyFromOthers
        briefId={briefId}
        deliverableConfigRefId={deliverableConfigRefId}
        taskConfigRefId={taskId}
        campaignInfluencerId={campaignInfluencerId}
        taskId={taskId}
        onSuccess={onClose}
        refetch={refetchInfluencer}
      />
    </Modal>
  );
}
